import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, ArrowRight} from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { BLOG_POSTS } from '@/lib/data';

export default function Blog() {
  const [selectedTag, setSelectedTag] = useState('all');
  const allTags = [...new Set(BLOG_POSTS.flatMap(p => p.tags))];
  const filtered = selectedTag === 'all' ? BLOG_POSTS : BLOG_POSTS.filter(p => p.tags.includes(selectedTag));

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="pt-24 pb-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="mb-10">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold">
            XceedEdge <span className="text-primary">Blog</span>
          </h1>
          <p className="text-muted-foreground mt-2">Insights, tips, and stories from the tech education world</p>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          <button
            onClick={() => setSelectedTag('all')}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
              selectedTag === 'all' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >All</button>
          {allTags.map(tag => (
            <button
              key={tag}
              onClick={() => setSelectedTag(tag)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
                selectedTag === tag ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >{tag}</button>
          ))}
        </div>

        <div className="space-y-6">
          {filtered.map((post, i) => (
            <motion.div
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              <Link to={`/blog/${post.id}`} className="group block bg-card rounded-xl border p-6 hover:shadow-lg transition-all hover:-translate-y-0.5">
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <Badge variant="secondary" className="text-xs">{post.category}</Badge>
                      <span className="text-xs text-muted-foreground flex items-center gap-1">
                        <Clock className="w-3 h-3" /> {post.readTime}
                      </span>
                    </div>
                    <h2 className="font-heading text-xl font-bold group-hover:text-primary transition-colors">{post.title}</h2>
                    <p className="text-muted-foreground text-sm mt-2 line-clamp-2">{post.excerpt}</p>
                    <div className="flex items-center gap-2 mt-3">
                      {post.tags.map(tag => (
                        <span key={tag} className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">{tag}</span>
                      ))}
                    </div>
                    <p className="text-xs text-muted-foreground mt-3">{new Date(post.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                  </div>
                  <div className="flex items-center">
                    <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}